import React from 'react';
import ReactDOM from 'react-dom/client';
import AppRoot from './AppRoot';
import { registerLocales } from './api/apiLocales';
import { initializeEzlogic } from './features/app';
import { initializeOpenTelemetryLogger } from './lib/opentelemetry';
import { runCacheMaintenance } from './helpers/cacheUtils';
import './lib/axios/middleware';

const rootElement = ReactDOM.createRoot(document.getElementById('app'));

// Render the React application to the DOM
function startApp() {
    return rootElement.render(<AppRoot />);
}

initializeEzlogic()
    .then(async () => await registerLocales())
    .then(initializeOpenTelemetryLogger)
    .then(startApp)
    .then(runCacheMaintenance);
